import { FormattedMessage } from "react-intl";
import UndoIcon from "@mui/icons-material/Undo";
import BaseButton from "./BaseButton";

const UndoButton = ({ disabled, onClick }) => (
  <BaseButton
    disabled={disabled}
    onClick={onClick}
    tooltip={
      <FormattedMessage id="admin.workspaces.imageSelector.buttons.undo.tooltip" />
    }
  >
    <UndoIcon sx={{ fontSize: "150%", margin: "0 4px 0 0" }} />
    <FormattedMessage id="admin.workspaces.imageSelector.buttons.undo.title" />
  </BaseButton>
);

export default UndoButton;
